import Vue from "vue";
import Router from "vue-router";
import BranchRouter from './branch'
import UserRouter from './enduser'
import ReporterRouter from './reporter'



Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        ...BranchRouter,
        ...UserRouter,
        ...ReporterRouter,
        {
            path: "/",
            name: "Home",
            component: () =>
                import("@/views/home/Home.vue"),
        },
        {
            path: "/index",
            name: "Index",
            component: () =>
                import("@/views/home/Index.vue"),
        },
        {
            path: "/loginWithOpenID",
            name: "OpenID",
            component: () =>
                import("@/views/login/loginWithOpenID"),
            hidden: true,
        },
       
       
    ],
});

export default router;